export default __webpack_public_path__ + "static/N0199-2f89aef56db338f2abecd7b5f26307bf.png";